import React from 'react';
import { useKeenSlider } from 'keen-slider/react';
import 'keen-slider/keen-slider.min.css';
import { ArrowLeft, ArrowRight } from 'lucide-react';

const WhyChooseGCCSection = ({ approachData = [] }) => {
    const [sliderRef, instanceRef] = useKeenSlider(
        {
            loop: true,
            breakpoints: {
                '(min-width: 640px)': {
                    slides: { perView: 2, spacing: 20 },
                },
                '(min-width: 1024px)': {
                    slides: { perView: 2.8, spacing: 24 },
                },
            },
            slides: { perView: 1.15, spacing: 16 },
        },
        [
            (slider) => {
                let timeout;
                let mouseOver = false;
                function clearNextTimeout() {
                    clearTimeout(timeout);
                }
                function nextTimeout() {
                    clearTimeout(timeout);
                    if (mouseOver) return;
                    timeout = setTimeout(() => {
                        slider.next();
                    }, 4000);
                }
                slider.on("created", () => {
                    slider.container.addEventListener("mouseover", () => {
                        mouseOver = true;
                        clearNextTimeout();
                    });
                    slider.container.addEventListener("mouseout", () => {
                        mouseOver = false;
                        nextTimeout();
                    });
                    nextTimeout();
                });
                slider.on("dragStarted", clearNextTimeout);
                slider.on("animationEnded", nextTimeout);
                slider.on("updated", nextTimeout);
                slider.on("destroyed", clearNextTimeout);
            },
        ]
    );

    if (!approachData || approachData.length === 0) return null;

    return (
        <section className="py-[60px] lg:py-[10px] bg-white overflow-hidden w-full font-sans">
            <div className="max-w-[1440px] w-full mx-auto px-[20px] lg:px-[80px]">

                {/* Top Header Row */}
                <div className="w-full flex flex-col lg:flex-row justify-between items-start lg:items-start mb-[36px] lg:mb-[48px] gap-6">
                    <div className="max-w-[500px]">
                        <h2 className="font-sora text-[20px] lg:text-[30px] font-[600] leading-[1.2] text-[#01386A] tracking-tight">
                            Why Choose Mobikode for Your GCC?
                        </h2>
                    </div>

                    <div className="max-w-full lg:max-w-[540px]">
                        <p className="font-graphik text-[14px] lg:text-[16px] font-[500] text-[#49577A] leading-[1.65]">
                            The right platform components for your current priorities, with security, governance, deployment, and cost controls considered as part of the same implementation.
                        </p>
                    </div>
                </div>

                {/* Slider Container */}
                <div ref={sliderRef} className="keen-slider py-2">
                    {approachData.map((item) => (
                        <div key={item.id} className="keen-slider__slide h-auto">
                            <div className="border border-[#D9E2EC] bg-white p-7 sm:p-9 lg:p-10 min-h-[260px] lg:min-h-[300px] flex flex-col justify-between transition-all duration-300 hover:shadow-[0_8px_30px_rgba(1,56,106,0.08)] h-full">
                                <div>
                                    <h3 className="font-sora text-[20px] lg:text-[24px] font-[600] text-[#01386A] tracking-tight mb-4">
                                        {item.title}
                                    </h3>
                                    <div className="w-[36px] h-[3px] bg-[#ED6800] mb-6" />
                                </div>

                                <p className="font-graphik text-[14px] sm:text-[16px] font-[500] leading-[1.65] text-[#49577A]">
                                    {item.desc}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Left Bottom Arrow Navigation */}
                <div className="flex items-center gap-3 mt-8">
                    <button
                        className="bg-transparent border border-[#ED6800] text-[#ED6800] rounded-full w-[34px] h-[34px] flex items-center justify-center cursor-pointer transition-all duration-300 hover:bg-[#ED6800] hover:text-white"
                        onClick={() => instanceRef.current?.prev()}
                        aria-label="Previous slide"
                    >
                        <ArrowLeft size={16} />
                    </button>
                    <button
                        className="bg-transparent border border-[#ED6800] text-[#ED6800] rounded-full w-[34px] h-[34px] flex items-center justify-center cursor-pointer transition-all duration-300 hover:bg-[#ED6800] hover:text-white"
                        onClick={() => instanceRef.current?.next()}
                        aria-label="Next slide"
                    >
                        <ArrowRight size={16} />
                    </button>
                </div>

            </div>
        </section>
    );
};

export default WhyChooseGCCSection;